module.exports = __webpack_public_path__ + "img/55fea39.jpg";